import { connect } from "react-redux";
import { default as AddSpecificationButton } from "./AddSpecificationButton";

// actions
import { selectProduct } from "store/actions/specifications";

// selectors
import { loadingSelector, articlesSelector } from "selectors/specifications";

const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  articles: articlesSelector(state),
});

const mapDispatchToProps = { selectProduct };

export default connect(mapStateToProps, mapDispatchToProps)(AddSpecificationButton);
